import getIgProfile from "./getIgProfile"
import changeIgProfile from "./changeIgProfile"

export { getIgProfile, changeIgProfile }

const instagram = { getIgProfile, changeIgProfile }

export default instagram
